import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ErrorLayout, ProtectedRoute, PublicRoute, FullScreenLayout } from 'modules/templates';
import requestRoutes from 'modules/request/routes';
import reportRoutes from 'modules/report/routes';
import schedulerRoutes from 'modules/scheduler/routes';
import settingsRoutes from 'modules/setting/routes';
import authRoutes from 'modules/auth/routes';
import modalRoutes from 'modules/modals/routes';
import Onboarding from './modules/auth/components/onboarding';

const publicRoutes = [...authRoutes.filter(route => !route.protected)];
const protectedRoutes = [
    ...authRoutes.filter(route => route.protected),
    ...modalRoutes,
    ...requestRoutes,
    ...reportRoutes,
    ...settingsRoutes,
    ...schedulerRoutes,
];
const RouteWrapper = ({ children, shouldShowOnboarding, location }) => {
    if (shouldShowOnboarding && location.pathname !== '/onboarding') {
        return <Redirect to="/onboarding" />;
    }
    return children;
};
const Routes = props => {
    return (
        <Route
            render={routeProps => (
                <RouteWrapper {...props} {...routeProps}>
                    <Switch>
                        {publicRoutes.map(route => (
                            <PublicRoute key={route.path} {...route} {...props} />
                        ))}

                        {protectedRoutes.map(route => (
                            <ProtectedRoute key={route.path} {...route} {...props} />
                        ))}

                        <ProtectedRoute
                            exact
                            path="/onboarding"
                            layout={FullScreenLayout}
                            component={Onboarding}
                            {...props}
                        />

                        <ErrorLayout {...props} />
                    </Switch>
                </RouteWrapper>
            )}
        />
    );
};

export { protectedRoutes as routes };
export default Routes;
